import { render, staticRenderFns } from "./Input-date.vue?vue&type=template&id=b18e09fc&scoped=true"
import script from "./Input-date.vue?vue&type=script&lang=ts"
export * from "./Input-date.vue?vue&type=script&lang=ts"
import style0 from "./Input-date.vue?vue&type=style&index=0&id=b18e09fc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b18e09fc",
  null
  
)

export default component.exports